

import { Vue, PropSync, Prop,Component } from "vue-property-decorator";
@Component({})
export default class DefaultContentLayoutTalentMapping extends Vue  {
  @Prop({ type: String, required: false, default: '' }) readonly leftClasses?: string;
  @Prop({ type: String, required: false, default: '' }) readonly rightClasses?: string;
  @Prop({ type: String, required: false, default: '' }) readonly containerClasses?: string;

}
  